/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import * as global from "../../js/global" ;
	import * as helper from "../../js/helper";
	import full_loading from "../components/full-loading.vue";
    import VueSelect from '../../js/vue-select.js';
	import property_information_component from "../components/property-information-component.vue";
	const __vue_script__ ={
        components: {
            full_loading:full_loading,
            vue_select:VueSelect,
            property_information_component:property_information_component,
        },
		name:'map_search_widget',
        props: { 
            property_json: {
                type: String,
            },
            property_features_json: {
                type: String,
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading:false,
                property_name: null,
				property: null,
                property_features:null,
                main_building: true,
                floor_index: "",
                children: null,
                amount: 0,
                type: null,
                description: "",
			}
		},
        mounted(){
            if(this.property_features_json != undefined)
                this.property_features = JSON.parse(this.property_features_json);
            var exampleModal = document.getElementById('childDetailsModal')
            exampleModal.addEventListener('show.bs.modal', this.load_property_data)
        },
		methods: {
            load_property_data: async function(event){
                this.loading = true;
				this.property = null;
                this.main_building = true;
                this.floor_index = "";
                this.children = null;
                this.type = null;
                this.amount = 0;
                // Button that triggered the modal
                var button = event.relatedTarget;
                // Extract info from data-bs-* attributes
                this.property_name = button.getAttribute('data-bs-property-name');
                this.form_sent = true;
                let params = {
                    property_name : this.property_name
                };
                try {
                    let res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.get_property_with_children",
                        type: "GET",
                        data: params //for GET request
                        // data: JSON.stringify(params) //for POST request
                    });
                    this.property = res.message
                    this.loading = false
                    
                    setTimeout(()=>{
                        $('.child-gallery-popup').each(function() {
                            $(this).magnificPopup({
                                delegate: 'a', 
                                type: 'image',
                                gallery: {
                                    enabled:true
                                }
                            });
                        });
                        $('.child-popup-youtube, .child-popup-vimeo').magnificPopup({
                            disableOn: 300,
                            type: 'iframe',
                            mainClass: 'mfp-fade',
                            removalDelay: 160,
                            preloader: false,
                            fixedContentPos: false,
                        });
                    }, 500);

                    this.$forceUpdate();
                } catch (e) {
                    console.log("failed")
                    console.log(e)
                    var exceptions = helper.showException(e);
                }
                
                this.loading = false
            }
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade filter-popup-area",
      attrs: {
        id: "childDetailsModal",
        "data-bs-keyboard": "false",
        tabindex: "-1",
        "aria-labelledby": "staticBackdropLabel",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog min-vw-80 modal-dialog-centered modal-dialog-scrollable"
        },
        [
          _vm.property != null
            ? _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c(
                    "h5",
                    {
                      staticClass: "modal-title",
                      attrs: { id: "staticBackdropLabel" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.helper.t("{0} Details", [
                            _vm.property.property_type
                          ])
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    staticClass: "btn-close",
                    attrs: {
                      type: "button",
                      "data-bs-dismiss": "modal",
                      "aria-label": "Close"
                    }
                  })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c("property_information_component", {
                      attrs: { property_data: _vm.property }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "add-listing col-12" }, [
                        _c(
                          "div",
                          { staticClass: "properties-details-content" },
                          [
                            _vm.property["description"]
                              ? _c(
                                  "div",
                                  { staticClass: "properties-about mb-4" },
                                  [
                                    _c("h3", { staticClass: "mb-1" }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.helper.t("Property Description")
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.property["description"])
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "features-content" }, [
                              _c("h3", { staticClass: "mb-1" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.helper.t("{0} Features", [
                                      _vm.property["property_type"]
                                    ])
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "row" },
                                _vm._l(_vm.property_features, function(
                                  feature,
                                  feature_index
                                ) {
                                  return _vm.property[feature] == 1
                                    ? _c("div", { staticClass: "col-lg-2" }, [
                                        _c("ul", [
                                          _c("li", [
                                            _c("i", {
                                              staticClass:
                                                "ri-checkbox-circle-fill"
                                            }),
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(_vm.helper.t(feature)) +
                                                "\n                                            "
                                            )
                                          ])
                                        ])
                                      ])
                                    : _vm._e()
                                }),
                                0
                              ),
                              _vm._v(" "),
                              false
                                ? _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-md-12" }, [
                                      _c("h3", { staticClass: "mb-1" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.helper.t("{0} Features", [
                                              _vm.property["property_type"]
                                            ])
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        _vm._l(_vm.property_features, function(
                                          feature,
                                          feature_index
                                        ) {
                                          return _vm.property[feature]
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "col-lg-2 col-md-3 col-sm-4"
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "ri-checkbox-circle-fill"
                                                  }),
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(
                                                        _vm.helper.t(feature)
                                                      ) +
                                                      "\n                                            "
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        }),
                                        0
                                      )
                                    ])
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            false
                              ? _c("div", { staticClass: "gap-mb-20" })
                              : _vm._e(),
                            _vm._v(" "),
                            false && _vm.property["floors"].length > 0
                              ? _c("div", { staticClass: "video-img" }, [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(_vm.helper.t("Sub Properties"))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {},
                                    _vm._l(_vm.property["floors"], function(
                                      floor
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass: "row floor-row mt-3 g-0"
                                        },
                                        [
                                          floor["floor_num"] == 0
                                            ? _c(
                                                "h3",
                                                { staticClass: "mx-2 my-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.helper.t(
                                                        "Ground Floor"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "h3",
                                                { staticClass: "mx-2 my-0" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.helper.t(
                                                        "Floor-{0}",
                                                        [floor["floor_num"]]
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "table",
                                            _vm._l(
                                              floor["property_types"],
                                              function(
                                                children,
                                                child_property_type
                                              ) {
                                                return _c("tr", [
                                                  _c("td", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.helper.t(
                                                          child_property_type
                                                        )
                                                      )
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "td",
                                                    _vm._l(children, function(
                                                      child_property,
                                                      child_property_index
                                                    ) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row property-div g-0 p-2"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-lg-12 g-0 hstack gap-1"
                                                            },
                                                            [
                                                              child_property[
                                                                "ad_type"
                                                              ] == "Rent"
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "badge bg-light text-dark"
                                                                    },
                                                                    [
                                                                      _c("i", {
                                                                        staticClass:
                                                                          "fa-solid fa-rotate"
                                                                      }),
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.helper.t(
                                                                              child_property[
                                                                                "rent_type"
                                                                              ]
                                                                            )
                                                                          ) +
                                                                          "\n                                                            "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm.property[
                                                                "own"
                                                              ]
                                                                ? [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "badge bg-light text-dark"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "i",
                                                                          {
                                                                            staticClass:
                                                                              "fa-solid fa-coins"
                                                                          }
                                                                        ),
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              child_property[
                                                                                "total_price"
                                                                              ]
                                                                            ) +
                                                                            "\n                                                                "
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _vm._v(" "),
                                                                    _c("p", [
                                                                      _vm._v(
                                                                        "\n                                                                    " +
                                                                          _vm._s(
                                                                            _vm.helper.t(
                                                                              "Expense Details"
                                                                            )
                                                                          )
                                                                      ),
                                                                      _c(
                                                                        "b",
                                                                        [
                                                                          false
                                                                            ? _c(
                                                                                "total_expense_component",
                                                                                {
                                                                                  attrs: {
                                                                                    property_name:
                                                                                      child_property[
                                                                                        "name"
                                                                                      ]
                                                                                  }
                                                                                }
                                                                              )
                                                                            : _vm._e()
                                                                        ],
                                                                        1
                                                                      )
                                                                    ])
                                                                  ]
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "btn default-btn small-btn equalizer ms-auto",
                                                                  attrs: {
                                                                    href: "#",
                                                                    "data-bs-toggle":
                                                                      "modal",
                                                                    "data-bs-target":
                                                                      "#childDetailsModal",
                                                                    "data-bs-property-name":
                                                                      child_property[
                                                                        "name"
                                                                      ]
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                                " +
                                                                      _vm._s(
                                                                        _vm.helper.t(
                                                                          "Details"
                                                                        )
                                                                      ) +
                                                                      "\n                                                            "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            2
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "property_features_component",
                                                            {
                                                              attrs: {
                                                                property_data: child_property
                                                              }
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }),
                                                    0
                                                  )
                                                ])
                                              }
                                            ),
                                            0
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "gap-mb-20" }),
                            _vm._v(" "),
                            _vm.property["video"]
                              ? _c("div", { staticClass: "video-img" }, [
                                  _c("h3", [
                                    _vm._v(
                                      _vm._s(_vm.helper.t("Property Video"))
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "video-wrap" }, [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "https://img.youtube.com/vi/" +
                                          _vm.property["video"].substring(
                                            _vm.property["video"].length - 11
                                          ) +
                                          "/maxresdefault.jpg",
                                        alt: "Image"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "video-button" }, [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "video-btn child-popup-youtube",
                                          attrs: {
                                            href:
                                              "https://www.youtube.com/watch?v=" +
                                              _vm.property["video"].substring(
                                                _vm.property["video"].length -
                                                  11
                                              ),
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "ri-play-fill"
                                          })
                                        ]
                                      )
                                    ])
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "gallery-area child-gallery-popup pt-20 pb-50"
                              },
                              [
                                _c("h3", [
                                  _vm._v(
                                    _vm._s(_vm.helper.t("Property Images"))
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "container" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "row justify-content-center"
                                    },
                                    _vm._l(_vm.property["images"], function(
                                      image
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-lg-4 col-sm-6 mix for-rent"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "single-gallery background-image",
                                              staticStyle: { color: "RED" },
                                              style: {
                                                "background-image":
                                                  "url(/" +
                                                  encodeURIComponent(
                                                    image.substr(1)
                                                  ) +
                                                  ")"
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: image,
                                                    target: "_blank"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass: "ri-eye-line"
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn default-btn mt-2",
                      attrs: { type: "button", "data-bs-dismiss": "modal" }
                    },
                    [_vm._v(_vm._s(_vm.helper.t("Close")))]
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-1f466872_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"child-details-modal.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/modal/child-details-modal.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__